import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Prices } from "./components/prices";
import { Contact } from "./components/contact";
import { Values } from "./components/values";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import { Services } from "./components/services";
import { TagLine } from "./components/tagLine";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <TagLine data={landingPageData.TagLine} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Srv} />
      <Prices data={landingPageData.Prices} />
      <Values data={landingPageData.Values} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

export default App;
